var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"config",staticClass:"drop-position refer",style:(_vm.concludeWH)},[_c('vue-drag-resize',{staticClass:"mark-out-position",attrs:{"x":_vm.referRectDetail.areaMinX,"y":_vm.referRectDetail.areaMinY,"w":_vm.operateWidth(_vm.referRectDetail),"h":_vm.operateHeight(_vm.referRectDetail)}},[[_c('div',{staticClass:"rect-title-wrap"})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }